import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { OverflowContextProvider } from 'modules/core/lib/overflowContext'

import MinutesToText from 'modules/attendance/components/MinutesToText'

import TooltipInfoRow from '../InfoRow'

interface Props {
  label: string
  value: number
  descriptions?: string[]
  plusSign?: boolean
  fallbackValue?: boolean
  multiLine?: boolean
}

interface ValueProps {
  value: number
  plusSign: boolean
  fallbackValue: boolean
}

const Value = ({ value, plusSign, fallbackValue }: ValueProps) => {
  if (fallbackValue && !value) {
    return (
      <Text color="grey000White" weight="medium" size="200">
        -
      </Text>
    )
  }

  return <MinutesToText value={value} color="grey000White" size="200" withPlusSign={plusSign} />
}

const TooltipRow = ({
  label,
  value,
  descriptions,
  plusSign = false,
  fallbackValue = false,
  multiLine = false,
}: Props) => {
  const ref = React.useRef(null)
  const paddingY = multiLine ? 's0' : 's4'

  return (
    <Box justifyContent="spaceBetween" paddingY={paddingY} gap="s1">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <OverflowContextProvider childrenRef={ref} value={label}>
          <Box textAlign="left">
            <Text color="grey000White" size="200" innerRef={ref} ellipsis>
              {label}
            </Text>
          </Box>
        </OverflowContextProvider>
        <Value value={value} plusSign={plusSign} fallbackValue={fallbackValue} />
      </Box>
      {descriptions &&
        descriptions.map((description, key) => <TooltipInfoRow key={key} label={description} />)}
    </Box>
  )
}

export default TooltipRow
